export const calculateBudgetTotals = (budget, expenses) => {
  const budgetValue = parseFloat(budget) || 0;
  const totalExpenses = (expenses || []).reduce(
    (sum, exp) => sum + (parseFloat(exp.amount) || 0),
    0
  );
  const remaining = budgetValue - totalExpenses;
  return { budgetValue, totalExpenses, remaining };
};
